import DOMPurify from 'dompurify'
import striptags from 'striptags'

export interface SanitizeHtmlOptions {
  /**
   * Tags to allow on top of DOMPurify's defaults. Callers that opt in to extra tags through
   * `HtmlContent`'s `includeTags` (e.g. `iframe` on legacy custom sections) pass them here.
   */
  addTags?: string[]
}

/**
 * Removes anything that can run script from stored rich text: event-handler attributes,
 * `javascript:` URLs, `<script>` and similar. Formatting from the editor is kept: `style`, `class`,
 * `data-*`, link `target`/`rel`, and the `contenteditable` flag on template-placeholder chips.
 *
 * Rich text can be written through the OpenAPI without any cleaning, so every place that renders it
 * as HTML must go through this.
 */
export function sanitizeHtml(html?: string | null, { addTags = [] }: SanitizeHtmlOptions = {}): string {
  if (!html) {
    return ''
  }

  // Without a DOM, DOMPurify cannot parse the HTML and returns it unchanged. Fail closed instead.
  if (!DOMPurify.isSupported) {
    return striptags(html)
  }

  return DOMPurify.sanitize(html, {
    ADD_TAGS: addTags,
    ADD_ATTR: ['target', 'contenteditable'],
    // Without this, content that starts with a <style> element is moved to <head> and dropped
    FORCE_BODY: true
  })
}
